import { CareerPathwayLevel } from "@/components/career-pathway-level"
import AppLayout from "@/layouts/AppLayout"

export default function CareerPathwayStaff() {
  return (
    <CareerPathwayLevel
      config={{
        name: "Staff",
        level: 5,
        emoji: "\ud83d\udc26\u200d\u2b1b",
        color: "red",
        comingSoon: true,
        description: "",
        sections: [],
        prev: { name: "Anterior: Senior", url: "/growth/career-pathway/senior" },
        next: { name: "Siguiente: Principal", url: "/growth/career-pathway/principal" },
      }}
    />
  )
}

CareerPathwayStaff.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
